import React, { useMemo } from "react";
import {
  DateRangePicker,
  FilterDropdown,
  Chip,
  Typography,
  Error,
} from "Components/shared/oneui";
import { DateRangeButton, FilterButton } from "./button-types";
import { event } from "dashboard-utils/lib/utils/clevertap";
import { getPageName } from "dashboard-utils/lib/constants";
import FilterErrorState from "./FilterErrorState";
export const getArrayFromDate = (intialDate) => {
  const date = new Date(intialDate);
  const dateArr = [];
  dateArr[0] = date.getFullYear();
  dateArr[1] = date.getMonth();
  dateArr[2] = date.getDate();

  return dateArr;
};

export const getDateFromArray = (dateArr) => {
  const date = new Date(...dateArr);
  return date;
};

export const dateRange = ({ dateFrom, dateTo, startTime, endTime }) => {
  const transformedVal = {
    startDate: getArrayFromDate(dateFrom),
    endDate: getArrayFromDate(dateTo),
  };
  return transformedVal;
};

const ToolBar = (props) => {
  const initialDate = useMemo(() => dateRange(props.filters), [props?.filters]);

  const minDateArr = useMemo(() => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 365);
    return getArrayFromDate(props?.minDate || minDate);
  }, [props?.minDate]);

  const handleDateRangeChange = (data) => {
    //--- for old rangeSelector
    // props.updateFilter({ ...data, pageOffset: 0, ...props.includeId });
    // wrapper for integrating new date range component
    const dateFrom = getDateFromArray(data?.startDate);
    const dateTo = getDateFromArray(data?.endDate);

    // const startTime = (dateFrom && format(dateFrom, "HH-mm-ss")) || "00:00:00";
    // const endTime = (dateTo && format(dateTo, "HH-mm-ss")) || "23:59:59";
    // setting to constant as api does not support custom values
    const startTime = "00:00:00";
    const endTime = "23:59:59";
    //---
    props.updateFilter({
      dateFrom,
      dateTo,
      startTime,
      endTime,
      pageOffset: 0,
      ...props.includeId,
    });
  };
  const filterBarOptions = useMemo(() => {
    const checkedOptions = [];
    props.filterOptions.forEach((filterOption) => {
      filterOption?.options?.forEach((option) => {
        if (option?.checked == true && option?.value) {
          checkedOptions.push({
            ...option,
            groupId: filterOption?.groupId,
            groupTitle: filterOption?.groupTitle,
          });
        }
      });
    });
    return checkedOptions;
  }, [props?.filters]);

  const checkedFilters = useMemo(() => {
    const checkedFilters = {};
    const _filterOption = props?.filterOptions || [];
    const selectedFilters = props?.filters?.filters;
    for (let filterKey in selectedFilters) {
      const _currentFilter = _filterOption.find((o) => o.groupId == filterKey);
      if (_currentFilter) {
        selectedFilters[filterKey].forEach((fKey) => {
          if (checkedFilters[_currentFilter.groupId]) {
            checkedFilters[_currentFilter.groupId][fKey] = true;
          } else {
            checkedFilters[_currentFilter.groupId] = {
              [fKey]: true,
            };
          }
        });
      }
    }
    return checkedFilters;
  }, [props.filters.filters]);

  const handleFilterChange = (data) => {
    event("Dashboard CTA clicked", {
      "CTA name": "Filter applied",
      "CTA page": getPageName(history?.location?.pathname?.split("/")?.pop()),
      "Section name": "Downtime Notification",
      "CTA type": "Filter",
    });
    const _filterOption = props?.filterOptions || [];
    const filters = {};
    for (let groupFilter in data) {
      const _currentFilter = _filterOption.find(
        (o) => o.groupId == groupFilter
      );
      if (_currentFilter) {
        for (let key in data[groupFilter]) {
          const option =
            _currentFilter.options?.find((o) => o.value === key) || {};
          if (data[groupFilter][key]) {
            option.checked = true;
            if (filters[_currentFilter.groupId]) {
              filters[_currentFilter.groupId].push(key);
            } else {
              filters[_currentFilter.groupId] = [key];
            }
          } else {
            option.checked = false;
          }
        }
      }
    }
    props.updateFilter({ filters });
  };

  const removeAllFilter = () => {
    const filterInScope = {};
    props.filterOptions.forEach((filterOption) => {
      filterOption?.options?.forEach((option) => {
        option.checked = false;
      });
      const id = filterOption?.groupId;
      filterInScope[id] = [];
    });
    props.updateFilter({ filters: { ...filterInScope }, pageOffset: 0 });
  };

  const removeSingleFilter = (option) => {
    const _filterOption = props?.filterOptions || [];
    const filterGroup = _filterOption.find((o) => o.groupId === option.groupId);
    const _option = filterGroup.options.find((o) => o.value === option.value);
    _option.checked = false;
    const filterInScope = props?.filters?.filters[option.groupId];
    const result = filterInScope.filter((value) => value != option.value);
    props.updateFilter({
      filters: {
        ...props?.filters?.filters,
        [option.groupId]: result,
      },
      pageOffset: 0,
    });
  };

  const renderFilterBar = () => (
    <div className="twside-w-full twside-flex twside-gap-16 twside-flex-wrap twside-overflow-x-scroll max-t:twside-flex-nowrap max-t:twside-gap-12 twside-items-center twside-py-8">
      {filterBarOptions?.map((elem) => (
        <Chip
          closeIconProps={{
            onClick: (event) => {
              event?.stopPropagation();
              removeSingleFilter(elem);
            },
          }}
          color="BLUE"
          onClick={(event) => {
            event?.stopPropagation();
          }}
          // startItem={<FileExcel variant="filled" size="m" />}
          type="REMOVABLE"
          value={elem?.label}
        />
      ))}
      {filterBarOptions?.length > 1 && (
        <Typography
          variant="SH4"
          onClick={(event) => {
            event.stopPropagation();
            removeAllFilter();
          }}
          className="twside-text-primary-500 twside-whitespace-nowrap twside-cursor-pointer"
          weight="bold"
        >
          Clear All
        </Typography>
      )}
    </div>
  );

  return (
    <>
      <div className="twside-flex twside-gap-12 twside-mb-20 twside-relative">
        <div className="toolbar_datepicker">
          <DateRangePicker
            onRangeSelect={handleDateRangeChange}
            showPresets={true}
            noOfMonthsToShow={2}
            {...initialDate}
            minDate={minDateArr}
            ButtonComponent={DateRangeButton}
          />
        </div>
        <div className="toolbar_filter">
          <FilterDropdown
            className=""
            onApply={handleFilterChange}
            onCancel={function noRefCheck() {}}
            checkedValues={checkedFilters}
            options={props.filterOptions}
            optionsGridContainerProps={{
              cols: 1,
              dCols: 1,
              dGap: 0,
              gap: 0,
              mCols: 1,
              mGap: 0,
              tCols: 1,
              tGap: 0,
            }}
            title="Filter"
            isLoading={props.isfilterOptionFetching}
            EmptyResults={
              props.filterOptionError
                ? () => <FilterErrorState onRetry={props.fetchFilterOptions} />
                : undefined
            }
            ButtonComponent={FilterButton}
          />
        </div>
      </div>
      {props.filterOptions?.length > 0 && renderFilterBar()}
    </>
  );
};

export default ToolBar;
